// extracted by mini-css-extract-plugin
export default {"main":"Modeling_main__sEkLi","cover":"Modeling_cover__MURdw","flex_col":"Modeling_flex_col__MljTm"};